import { publicEnvConfig } from 'helpers/env';

export const trackLoggedInOrttoUser = ({ ap3c, trackingId, payload, disableWidgets = false } = {}) => {
	if (!ap3c || !trackingId || !payload) {
		return;
	}

	ap3c.cmd.push(function () {
		ap3c.init(trackingId, publicEnvConfig.NEXT_PUBLIC_ORTTO_CAPTURE_API_URL, {
			disableWidgets,
		});

		ap3c.track(payload);
	});
};
